/**
 * Campo numerico memoizzato con debounce locale
 * @module flyers/components/fields/MemoizedNumberField
 */

import React from "react";
import { Input } from "antd";
import FloatingField from "@shared/components/FloatingField.jsx";

/**
 * Campo numerico ottimizzato con stato locale e propagazione onBlur
 */
const MemoizedNumberField = React.memo(({ fieldKey, label, value, onChange, disabled }) => {
    const [localValue, setLocalValue] = React.useState(value ?? "");

    React.useEffect(() => {
        setLocalValue(value ?? "");
    }, [value]);

    const handleChange = React.useCallback((event) => {
        setLocalValue(event.target.value);
    }, []);

    const handleBlur = React.useCallback(() => {
        if (localValue !== value) {
            onChange(fieldKey, localValue);
        }
    }, [fieldKey, onChange, value, localValue]);

    return (
        <FloatingField label={label}>
            <Input
                type="number"
                placeholder={label}
                value={localValue}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={disabled}
            />
        </FloatingField>
    );
}, (prevProps, nextProps) => {
    return (
        prevProps.value === nextProps.value &&
        prevProps.disabled === nextProps.disabled &&
        prevProps.fieldKey === nextProps.fieldKey
    );
});

MemoizedNumberField.displayName = "MemoizedNumberField";

export default MemoizedNumberField;
